import React from 'react';

const TICKER_ITEMS = [
  { highlight: 'As Heard On', detail: 'talkSPORT' },
  { highlight: 'As Seen On', detail: 'Sky TV' },
  { highlight: '140,000+', detail: 'Registered Anglers' },
  { highlight: '300+', detail: 'Fisheries Live' },
  { highlight: '17,000+', detail: 'Facebook Followers' },
  { highlight: '14,000+', detail: 'TikTok Followers' },
  { highlight: '8,000+', detail: 'Instagram Followers' },
  { highlight: '4.7 On Trustpilot', detail: '2,000+ Reviews' },
];

function StatsTicker() {
  return (
    <div className='hh-ticker overflow-hidden hh-enter hh-enter--ticker'>
      <div className='hh-ticker__track'>
        {[false, true].map((isCopy) => (
          <ul
            key={isCopy ? 'copy' : 'original'}
            className='hh-ticker__group pd-0 mg-0'
            aria-hidden={isCopy || undefined}
          >
            {TICKER_ITEMS.map(({ highlight, detail }) => (
              <li key={highlight} className='hh-ticker__item txt-nowrap fs-14'>
                <span className='gSemiBold white'>{highlight}</span>{' '}
                <span className='gRegular sb-blue-100'>{detail}</span>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}

export default StatsTicker;
